<template>
  <PageShell :background="background" wide>
    <PageHeader
      size="page"
      align="start"
      :title="t('faq.title')"
      :lead="t('faq.description')"
    />

    <IndexedLayout :items="indexItems" :label="t('faq.sections.label')">
      <PageSection
        v-for="group in groups"
        :id="group.id"
        :key="group.id"
        :title="t(`faq.groups.${group.key}.title`)"
      >
        <FAQ :ids="group.ids" :default-open="group.defaultOpen" />
      </PageSection>
    </IndexedLayout>

    <ClosingCta />
  </PageShell>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import PageShell from '@/components/public/PageShell.vue';
import PageHeader from '@/components/public/PageHeader.vue';
import PageSection from '@/components/public/PageSection.vue';
import IndexedLayout from '@/components/public/IndexedLayout.vue';
import ClosingCta from '@/components/public/ClosingCta.vue';
import FAQ from '@/components/FAQ.vue';
import background from '@/assets/images/backgrounds/common/city-night.webp';

const { t } = useI18n();

/*
 * The eight questions were one flat accordion under a "Questions and answers"
 * h2 that existed only to give the h3 triggers a parent. Three topical groups
 * give each h3 a heading that says something, and give the in-page index
 * something to index. The first group's first answer opens by default so the
 * page has content above the fold rather than title-plus-lead.
 */
const groups = [
  { id: 'faq-the-game', key: 'theGame', ids: ['whatIsDimensionX', 'canSwitchDimensions'], defaultOpen: [0] },
  { id: 'faq-getting-started', key: 'gettingStarted', ids: ['howToStart', 'platforms'], defaultOpen: [] },
  {
    id: 'faq-the-project',
    key: 'theProject',
    ids: ['whoDeveloping', 'provideFeedback', 'stayUpdated', 'supportDevelopment'],
    defaultOpen: [],
  },
];

const indexItems = computed(() =>
  groups.map((group) => ({ id: group.id, label: t(`faq.groups.${group.key}.title`) })),
);
</script>
